export enum ElmAssistSupportScope {
  PreSales = 1,
  AfterSales = 2,
}
